export const MODAL_DIALOG__EDIT_SITE_TEXT = 'MODAL_DIALOG__EDIT_SITE_TEXT';
